<template>
  <div data-cy="login">
    <errors v-if="errorMessage" :error="errorMessage" class="mb-4 mt-1" data-cy="login-errors" />

    <b-form v-if="!isSuccess" @submit="triggerLogin">
      <fieldset class="form-group mt-3" data-cy="login-fieldset">
        <div class="pr-3">
          <p class="mb-0 text-uppercase font-weight-bold">
            {{ "Email" | __t("input__email") }}
          </p>

          <div class="p-1  rounded">
            <base-input v-model="email" placeholder="mycoolmail@email.com" @keyup.enter="triggerLogin" :disabled="isSending" />
          </div>
        </div>
      </fieldset>

      <div class="text-center mt-3">
        <b-button
          @click="triggerLogin"
          class="mt-4 mb-3 pl-4 pr-4 w-100 rounded text-capitalize font-poppins"
          variant="success"
          data-cy="login-submit"
          :disabled="isSending"
        >
          {{ cta | __t(`auth__magic-link__${toSlug(cta)}`) }}
        </b-button>

        <small>
          <em>
            {{ footprint | __t(`auth__magic-link__${toSlug(footprint)}`) }}
          </em>
        </small>
      </div>
    </b-form>

    <div v-else-if="isSuccess && isShowingConfirmation" data-cy="success-screen" class="text-center">
      <h3 class="mt-50 text-center text-uppercase text-white">
        {{ "The Email Was Sent" | __t("auth__magic-link__headline__the-email-was-sent") }}
      </h3>

      <p class="mb-50 text-center">
        {{
          "Please, check your inbox and click the link to continue sign-in/register process."
            | __t("auth__magic-link__please-check-your-inbox-and-click-the-link")
        }}
      </p>

      <div class="text-center text-white">
        <b-button variant="outline-primary" @click="triggerResend">
          <span class="text-uppercase">{{ "Send again" | __t("button__send-again") }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { SEND_LOGIN_LINK } from "@/store/actions";

import { BForm, BButton } from "bootstrap-vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

import { toSlug } from "@/helpers/utils";
import { encodeAsFirebaseKey } from "@/helpers/utils";

import Errors from "@/components/Data/Errors";
import BaseInput from "@/components/Forms/Base/BaseInput";

export default {
  name: "LoginByLinkForm",
  mixins: [validationMixin],
  components: { Errors, BForm, BaseInput, BButton },
  props: {
    title: {
      type: String,
      default: "Login With Magic Link",
    },
    cta: {
      type: String,
      default: "Request Magic Link",
    },
    footprint: {
      type: String,
      default: "A one-click login/register link will be emailed to you",
    },
    bookName: {
      type: String,
      default: "",
    },

    isShowingConfirmation: {
      type: Boolean,
      defaut: true,
    },
    isLanding: {
      type: Boolean,
      defaut: false,
    },
    theme: {
      type: String,
      default: "white",
      validator: (v) => ["white", "beige", "dark"].includes(v),
    },
  },
  computed: {
    query() {
      const { email, isLanding } = this;
      const FIREmail = encodeAsFirebaseKey(email);

      if (isLanding) return `tags=SEQUENCE&lp=v2&email=${FIREmail}`;
      return `email=${FIREmail}`;
    },
  },
  data() {
    return {
      email: null,
      password: null,

      errorMessage: null,

      hasSubmitError: null,
      isSending: false,
      isSuccess: false,
    };
  },
  methods: {
    ...mapActions("auth", { sendLoginLink: SEND_LOGIN_LINK }),
    async triggerLogin(e) {
      if (e) e.preventDefault();

      this.errorMessage = null;

      this.$v.$touch();
      if (this.$v.$invalid) {
        this.hasSubmitError = true;
        return;
      }

      this.isSending = true;

      const { email, query, bookName } = this;

      const { isSuccess, error } = await this.sendLoginLink({ email, query, bookName });

      if (isSuccess) {
        this.isSuccess = isSuccess;
        this.$emit("success", email);
        return;
      }

      this.errorMessage = error;
      this.isSending = false;
    },
    triggerResend() {
      this.isSuccess = false;
      this.triggerLogin();
    },

    toSlug,
  },
  validations: {
    email: {
      required,
      email,
    },
    // password: {
    //   required,
    // },
  },
};
</script>
